/** Self-Check uses its own reveal flow — no post-check peek buttons. */
export function exerciseSkipsAnswerPeek(ex) {
    return ex?.type === 'fill_gaps_self_check' || ex?.type === 'fill_gaps_ai';
}

/** Whether Mark as Checked should ask the teacher about answer peek (non-block, non-self-check). */
export function shouldPromptShowAnswersOnCheck(ex) {
    return !!ex && !exerciseSkipsAnswerPeek(ex);
}

/**
 * Student may toggle peek on a wrong item, or teacher in review mode (always, for sanity-check).
 */
export function canUseAnswerPeek({ assignment, reviewMode, isWrong, hasKey }) {
    if (!hasKey || !isWrong) return false;
    if (reviewMode) return true;
    return assignment?.status === 'checked' && assignment?.show_correct_answers === true;
}

/** Non-empty Answers HTML on the exercise template. */
export function exerciseHasAnswersHtml(ex) {
    const raw = String(ex?.answers_html || '');
    const trimmed = raw.replace(/<br\s*\/?>/gi, '').replace(/&nbsp;/g, ' ').replace(/<[^>]+>/g, '').trim();
    return trimmed.length > 0;
}

/**
 * Show the Answers block at the end of interactive (not Online Lesson — that uses the teacher panel).
 * Students: only when assignment is checked and show_answers_html is true.
 * Teachers (review / preview / teacher without assignment): always if content exists.
 */
export function canShowExerciseAnswers({
    assignment,
    reviewMode = false,
    isTeacher = false,
    isOnlineLesson = false,
    preview = false,
} = {}) {
    if (isOnlineLesson) return false;
    if (reviewMode || preview || (isTeacher && !assignment)) return true;
    return assignment?.status === 'checked' && assignment?.show_answers_html === true;
}
